import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "crv-vuetify-styling" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SireHeader = _resolveComponent("SireHeader")!
  const _component_MaintenanceView = _resolveComponent("MaintenanceView")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_RefinerButton = _resolveComponent("RefinerButton")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SireHeader),
        (_ctx.maintenanceView)
          ? (_openBlock(), _createBlock(_component_MaintenanceView, { key: 0 }))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ]),
      _createVNode(_component_RefinerButton)
    ]),
    _: 1
  }))
}